
export default {
    zh:{
        sourcingNo:'报价确认单据编号',
        applyNo : '线路报价申请单',
        applyType: '类型',
        subject : '主题' ,
        quotationType : '报价类型' ,
        supplierCode : '供应商编号',
        supplierName : '供应商名称',
        pickupPoint : '发货市',
        dc : '到货仓库',
        temperature : '温区',
        transportaionMethod : '运输方式',
        selSendMailData : '请选择需要发送中标通知书的数据',
        unqualifiedData : '选择中包含未完成审核数据',
        confirmSendMail : '确认发送邮件',
        sendMailFailed : '发送邮件失败',
        sendMailSuccess : '成功发送邮件',
        finalSupplier : '最终供应商',
        itemNo: '行号',
        unit :'结算单位',
        effectiveBeginDate : '有效开始日期',
        price : '报价(不含税)',
        currentPrice : '线路现行价格',
        currentSupplier : '线路现行供应商',
        currencyCode : '币种',
        remarks : '备注',
        selSourcingData :'请选择需要报价确认的数据',
        youCanOnlySendMailToApprovedData :'只能给审核通过的数据发送中标通知书',
        dataError : '相同路线只能选择一个承运商',
        success : '提交成功',
        fail : '提交失败',
        confirmSubmit :'确认提交数据',
        submitTitle: '报价确认',
        auditor:'审核人',
        auditDate:'审核日期',
        lineType:"线路类型",
    },
    en:{
        lineType:"线路类型",
        sourcingNo:'Soucing No',
        youCanOnlySendMailToApprovedData :'You can only send mail to approved data',
        applyNo : 'Quotation Apply No',
        applyType: 'Apply Type',
        subject : 'Subject',
        quotationType : 'Quotation Type' ,
        supplierCode : 'Supplier No',
        supplierName : 'Supplier Name',
        pickupPoint : 'Pickup Point',
        dc : 'DC' ,
        temperature : 'Temperature',
        transportaionMethod : 'Transportaion Method',
        selSendMailData : 'Please select the data to be sent',
        unqualifiedData : 'The selection contains incomplete audit data',
        confirmSendMail : 'Confirm sending email',
        sendMailFailed : 'Failed to send email',
        sendMailSuccess : 'Successfully sent email',
        finalSupplier : 'Final Supplier',
        itemNo: 'Item No',
        unit : 'Unit',
        effectiveBeginDate : 'Effective Begin Date' ,
        price : 'Price(tax-exclusive)',
        currentPrice : 'Current Price',
        currentSupplier : 'Current Supplier',
        currencyCode : 'Currency',
        remarks : 'Remarks',
        selSourcingData :'Please select the data to confirm',
        dataError : 'Only one carrier can be chosen for the same route',
        success : 'Submit successfully',
        fail : 'Submit failure',
        confirmSubmit: 'Confirm submitted data',
        submitTitle: 'Sourcing',
        auditor: 'Auditor',
        auditDate:'Audit Date'
    }
}
